import React, {useState, useEffect, useRef} from "react";
import {DEFAULT_BLUE} from "../../../constants/general-constants";
import {functions} from "../../../constants/common-functions";
import {STRINGIFY} from "../../../constants/general-constants";
import {INPUT_TYPE_TEXT} from "../../../constants/input-types";
import {INPUT_TYPE_TEXTAREA} from "../../../constants/input-types";
import {INPUT_TYPE_SELECT} from "../../../constants/input-types";
import EditChildPanel from '../components/EditChildPanel';
import UserFacilityMatrixRow from '../components/UserFacilityMatrixRow';
import {YES_NO_OPTIONS} from "../../../constants/general-constants";

export default function AdminListPanelUserHomePage({userId, setFunction}){
	
	const [homepages, setHomepages] = useState([]);
	const [userHomepages, setUserHomepages] = useState([]);
	
	useEffect(() => {
		loadFacilities();
	}, [userId]);
	
	const loadFacilities = () => {
		functions.getArrayFromAjax("/resolution/clienthomepagelinks",  setHomepages, loadUserHomepages);
	};
	
	
	const loadUserHomepages = (thisHomepages) => {
		functions.getArrayFromAjax("/resolution/userhomepages?userId=" + userId,  setUserHomepages, setChecked);
	};
	
	const setChecked = (returnedArray) => {
		setFunction(returnedArray);
		for(let i=0; i<returnedArray.length; i++){
			document.getElementById("checkhomepage" + returnedArray[i].clientHomepageLinkId).checked = true;
		}
	};
	
	const thisContainer = {
		display:"flex",
		width:"calc(50% - 40px)",
		backgroundColor:"#eee",
		borderRadius:"4px",
		minHeight:"200px",
		marginLeft:"30px",
		flexDirection:"column",
		paddingBottom:"30px",
		marginTop:"30px"
	};
	
	const titlePanel = {
		display:'flex',
		width:"calc(100% - 20px)",
		alignItems:"center",
		justifyContent:"space-between",
		color:"black",
		height:"40px",
		fontSize:"14px",
		marginLeft:"10px"
	};
	
	const blueButton = {
		display:"flex",
		width:"100px",
		height:"20px",
		backgroundColor:DEFAULT_BLUE,
		borderRadius:"15px",
		color:"white",
		fontSize:"12px",
		cursor:"pointer",
		marginRight:"10px",
		marginTop:"0px",
		alignItems:"center",
		justifyContent:"space-around",
		boxShadow:'0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.13)',
	};
	
	const rowContainer = {
		display:"flex",
		width:"calc(100% - 10px)",
		marginLeft:"5px",
		flexDirection:"column",
		marginTop:"10px"
	};
	
	const row = {
		display:"flex",
		width:"calc(100% - 40px)",
		marginLeft:"20px",
		backgroundColor:"white",
		marginTop:"1px",
		alignItems:"center",
		height:"30px"
	};
	
	const thisCheck = {
		display:"flex",
		width:"15px",
		height:"15px",
		backgroundColor:"rgba(0,0,0,0)",
		border:"1px solid #ddd",
		marginLeft:"5px"
	};
	
	const checkText = {
		display:"flex",
		marginLeft:"5px",
		color:"black",
		fontSize:"12px"
	};
	
	const handleCheck = (e, inputId) => {
		let tempUserHomepages = [];
		for(let i=0; i<userHomepages.length; i++){
			if(inputId != userHomepages[i].clientHomepageLinkId){
				tempUserHomepages.push({
				id:"-100",
				userId:userHomepages[i].userId,
				clientHomepageLinkId:userHomepages[i].clientHomepageLinkId
			});		
			}
		}
		
		if(e.target.checked === true){
			tempUserHomepages.push({
				id:"-100",
				userId:userId,
				clientHomepageLinkId:inputId
			});				
		}	
		
		setFunction(tempUserHomepages);
		setUserHomepages(tempUserHomepages);
	};
	
	const rowDisplay = homepages.map((item, index) => 
		<div style={row}>
			<input type="checkbox" style={thisCheck} onChange={(e) => {handleCheck(e, item.id)}} id={"checkhomepage" + item.id}/>
			<div style={checkText}>
				{item.name}
			</div>
		</div>
	);
	
	return (
		<div style={thisContainer}>
			<div style={titlePanel}>
				Allocate Modules To Home Page
			</div>
			<div style={rowContainer}>
				{rowDisplay}
			</div>		
		</div>
		
	);
}